export default __webpack_public_path__ + "assets/images/74b5192e05b324b49c6f66bdb0e0dce7.png";